import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=ade44fbc&scoped=true&"
import script from "./order-card.vue?vue&type=script&lang=js&"
export * from "./order-card.vue?vue&type=script&lang=js&"
import style0 from "./order-card.vue?vue&type=style&index=0&id=ade44fbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade44fbc",
  null
  
)

export default component.exports